<template>
	<div class="basicinfo">
		<div class="site_top">
			<h3>基本资料</h3>
			<span class="line"></span>
		</div>
		<div class="form_panel">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" size="small" label-width="110px" class="demo-ruleForm">
				<div class="title">
					<span>账户信息</span>
					<span class="isEdit" @click="editChangeHandle()">{{ isDisabled ? '编辑' : '取消' }}</span>
				</div>
				<transition name="fade-transform">
					<div class="divtips" v-if="!isDisabled">提示：编辑内容涉及重要信息，一经修改需平台进行审核，审核期间不支持仪器下单及预约等功能。</div>
				</transition>
				<el-row type="flex" justify="space-around">
					<el-col :span="10">
						<el-form-item label="委托类型" prop="userType">
							<el-radio-group v-model="ruleForm.userType" @change="userTypeChanege" :disabled="isDisabled">
								<el-radio :label="2">外部用户</el-radio>
								<el-radio :label="1">内部用户</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="用户名" prop="username">
							<el-input v-model="ruleForm.username"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row type="flex" justify="space-around">
					<el-col :span="10">
						<el-form-item label="手机号码" prop="phone">
							<el-input v-model="ruleForm.phone" :disabled="isDisabled"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10"> </el-col>
				</el-row>
				<el-row type="flex" justify="space-around">
					<el-col :span="10">
						<el-form-item label="姓名" prop="name">
							<el-input v-model="ruleForm.name" :disabled="isDisabled"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="邮箱" prop="email">
							<el-input v-model="ruleForm.email" :disabled="isDisabled"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row type="flex" justify="space-around">
					<el-col :span="10">
						<el-form-item label="QQ号" prop="qq">
							<el-input v-model="ruleForm.qq"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="微信号" prop="wx">
							<el-input v-model="ruleForm.wx"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<div class="upInfo">
					<el-row type="flex" justify="space-around">
						<el-col :span="12">
							<el-form-item label="电子签名" prop="electronName">
								<el-row>
									<el-col :span="12">
										<el-upload
											class="sign-uploader euploader"
											:action="fileUploadUrl"
											:show-file-list="false"
											:on-success="handleSignSuccess"
											accept=".png,.jpg,.jpeg,.bmp,.tif,.pcx,.svg,.webp"
										>
											<img v-if="signImageUrl" :src="signImageUrl" class="signimg" />
											<div v-else class="desc">
												<i class="el-icon-plus euploader-icon"></i>
												<p>上传签名</p>
											</div>
										</el-upload>
									</el-col>
									<el-col :span="12">
										<div class="shili">
											<span>示例：</span>
											<img style="width: 105px" src="@/assets/img/shili.png" alt="" />
										</div>
									</el-col>
								</el-row>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="用户头像" prop="avatar">
								<el-upload class="avatar-uploader euploader" :action="fileUploadUrl" :show-file-list="false" :on-success="handleAvatarSuccess" accept=".png,.jpg,.jpeg,.bmp,.tif,.pcx,.svg,.webp">
									<img v-if="avatarImageUrl" :src="avatarImageUrl" class="avatar" />
									<div v-else class="desc">
										<i class="el-icon-plus euploader-icon"></i>
										<p>上传头像</p>
									</div>
								</el-upload>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row type="flex" justify="space-around">
						<el-col :span="10">
							<el-form-item label="">
								<div class="tips">
									<h3>电子签名制作方式</h3>
									<p>
										方法一：在白纸上手写签名，使用Photoshop等图片处理软件制作成无背底的图片。
										<br />
										方法二：使用手机备忘录或类似APP，选择色黑较粗的笔书写，截取签名并上传图片。 要求：签名四周不留白，图片为PNG格式。
									</p>
								</div>
							</el-form-item>
						</el-col>
						<el-col :span="10"> </el-col>
					</el-row>
				</div>
				<div class="title">
					<span>委托单位</span>
				</div>
				<el-row type="flex" justify="space-around" v-if="ruleForm.userType == '1'">
					<el-col :span="10">
						<el-form-item label="单位名称" prop="deptName">
							<el-input v-model.trim="ruleForm.deptName" :disabled="isDisabled" @keydown.native="keydown($event)"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item prop="department" label="部门/学院/课题组名称">
							<el-input v-model.trim="ruleForm.department" @keydown.native="keydown($event)"></el-input>
						</el-form-item>

						<!-- <el-form-item prop="department">
							<template v-slot:label>
								<span class="mylableline">部门/学院/课题组名称</span>
							</template>
							<el-input v-model="ruleForm.department"></el-input>
						</el-form-item> -->
					</el-col>
				</el-row>
				<template v-if="ruleForm.userType == '1'">
					<el-row type="flex" justify="space-around">
						<el-col :span="10">
							<el-form-item label="项目名称" prop="proName">
								<el-input v-model.trim="ruleForm.proName" :disabled="isDisabled" @keydown.native="keydown($event)"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="项目编号" prop="proNumber">
								<el-input v-model.trim="ruleForm.proNumber" :disabled="isDisabled" @keydown.native="keydown($event)"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row type="flex" justify="space-around">
						<el-col :span="10">
							<el-form-item label="项目类别" prop="proType">
								<el-select v-model="ruleForm.proType" class="w100" placeholder="请选择项目类别" :disabled="isDisabled">
									<el-option :label="item.val" :value="item.code" v-for="item of proTypeOptions" :key="item.code"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="研究方向" prop="researchDrct">
								<el-select v-model="ruleForm.researchDrct" class="w100" placeholder="请选择研究方向" :disabled="isDisabled">
									<el-option :label="item.val" :value="item.code" v-for="item of yjfxOptions" :key="item.code"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row type="flex" justify="space-around">
						<el-col :span="10">
							<el-form-item label="项目负责人" prop="proLeader">
								<el-input v-model.trim="ruleForm.proLeader" :disabled="isDisabled" @keydown.native="keydown($event)"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="联系方式" prop="proLeaderTel">
								<el-input v-model.trim="ruleForm.proLeaderTel" :disabled="isDisabled" @keydown.native="keydown($event)"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row type="flex" justify="space-around">
						<el-col :span="10">
							<el-form-item label="结算负责人" prop="proSettler">
								<el-input v-model.trim="ruleForm.proSettler" :disabled="isDisabled" @keydown.native="keydown($event)"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="联系方式" prop="proSettlerTel">
								<el-input v-model.trim="ruleForm.proSettlerTel" :disabled="isDisabled" @keydown.native="keydown($event)"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row type="flex" justify="space-around">
						<el-col :span="10">
							<el-form-item label="项目结题时间" prop="proConclusionTime">
								<el-date-picker
									type="date"
									placeholder="项目结题时间"
									:disabled="isDisabled"
									v-model="ruleForm.proConclusionTime"
									format="yyyy-MM-dd"
									value-format="timestamp"
									style="width: 100%"
								></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="区域邮编" prop="">
								<el-input v-model="ruleForm.postcode" :disabled="isDisabled"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</template>
				<el-row type="flex" justify="space-around" v-if="ruleForm.userType == '1'">
					<el-col :span="10">
						<el-form-item label="所在地" prop="">
							<el-input v-model="ruleForm.location" :disabled="isDisabled"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="详细地址" prop="">
							<el-input v-model="ruleForm.addr" :disabled="isDisabled"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row type="flex" justify="space-around" v-if="ruleForm.userType == '2'">
					<el-col :span="10">
						<el-form-item label="单位名称" prop="deptName">
							<el-input v-model.trim="ruleForm.deptName" @keydown.native="keydown($event)"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="详细地址" prop="">
							<el-input v-model="ruleForm.addr"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<div class="title">
					<span>开票信息</span>
				</div>
				<el-row type="flex" justify="space-around">
					<el-col :span="10">
						<el-form-item label="单位名称" prop="billComName">
							<el-input v-model="ruleForm.billComName"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="单位地址" prop="billComAddress">
							<el-input v-model="ruleForm.billComAddress"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row type="flex" justify="space-around">
					<el-col :span="10">
						<el-form-item label="单位电话" prop="billComPhone">
							<el-input v-model="ruleForm.billComPhone"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="税务登记号" prop="billRegNumber">
							<el-input v-model="ruleForm.billRegNumber"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row type="flex" justify="space-around">
					<el-col :span="10">
						<el-form-item label="开户银行" prop="billBankName">
							<el-input v-model="ruleForm.billBankName"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="开户账号" prop="billBankNumber">
							<el-input v-model="ruleForm.billBankNumber"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item>
					<div class="btn-control">
						<el-button type="primary" round class="elbtnColor" @click="submitForm" size="medium">确认修改</el-button>
					</div>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
import { isMobile, isEmail } from '@/utils/validate'
import storageUtils from '@/utils/storageUtils.js'
export default {
	data() {
		var validateBus = (rule, value, callback) => {
			console.log(this.ruleForm.electronName)
			if (!this.ruleForm.electronName) {
				callback(new Error('上传电子签名'))
			} else {
				callback()
			}
		}
		// var validateAvatar = (rule, value, callback) => {
		// 	if (!this.ruleForm.avatar) {
		// 		callback(new Error('上传用户头像'))
		// 	} else {
		// 		callback()
		// 	}
		// }
		var validateMobile = (rule, value, callback) => {
			if (!isMobile(value)) {
				callback(new Error('手机号格式错误'))
			} else {
				callback()
			}
		}
		var validateEmail = (rule, value, callback) => {
			if (!isEmail(value)) {
				callback(new Error('邮箱格式错误'))
			} else {
				callback()
			}
		}
		return {
			isDisabled: true,
			avatarImageUrl: '',
			signImageUrl: '',
			proTypeOptions: [],
			yjfxOptions: [],
			ruleForm: {
				userType: '2',
				username: '',
				phone: '',
				captchaPhone: '',
				name: '',
				email: '',
				qq: '',
				wx: '',
				electronName: '',
				avatar: '',
				deptName: '',
				department: '',
				proName: '',
				proNumber: '',
				proType: '',
				researchDrct: '',
				proConclusionTime: '',
				proLeader: '',
				proLeaderTel: '',
				proSettler: '',
				proSettlerTel: '',
				location: '',
				addr: '',
				postcode: '',
				billComName: '',
				billComAddress: '',
				billComPhone: '',
				billRegNumber: '',
				billBankName: '',
				billBankNumber: '',
			},
			rules: {
				userType: [{ required: true, message: '请选择委托类型', trigger: 'change' }],
				username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
				phone: [
					{ required: true, message: '请输入手机号码', trigger: 'blur' },
					{ validator: validateMobile, trigger: 'blur' },
				],
				captchaPhone: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
				name: [
					{ required: true, message: '请输入姓名', trigger: 'blur' },
					{ min: 0, max: 20, message: '长度在20个字符内', trigger: 'blur' },
				],
				electronName: [{ required: true, validator: validateBus, trigger: 'change' }],
				// avatar: [{ required: true, validator: validateAvatar, trigger: 'change' }],
				department: [{ required: true, message: '请输入部门/学院/课题组名称', trigger: 'blur' }],
				deptName: [{ required: true, message: '请输入单位名称', trigger: 'blur' }],
				proName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
				proNumber: [{ required: true, message: '请输入项目编号', trigger: 'blur' }],
				proType: [{ required: true, message: '请选择项目类别', trigger: 'change' }],
				researchDrct: [{ required: true, message: '请选择研究方向', trigger: 'change' }],
				proConclusionTime: [{ required: true, message: '项目结题时间', trigger: 'change' }],
				proLeader: [{ required: true, message: '请输入项目负责人', trigger: 'blur' }],
				proLeaderTel: [{ required: true, message: '项目负责人联系方式', trigger: 'blur' }],
				proSettler: [{ required: true, message: '请输入结算负责人', trigger: 'blur' }],
				proSettlerTel: [{ required: true, message: '结算负责人联系方式', trigger: 'blur' }],
				location: [{ required: true, message: '请输入所在地', trigger: 'blur' }],
				addr: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
				postcode: [{ required: true, message: '请输入区域邮编', trigger: 'blur' }],
				email: [
					{ required: true, message: '请输入邮箱', trigger: 'blur' },
					{ validator: validateEmail, trigger: 'blur' },
				],
			},
		}
	},
	computed: {
		fileUploadUrl() {
			return window.SITE_CONFIG.fileUpload
		},
		filePreview() {
			return window.SITE_CONFIG.previewFile
		},
	},
	created() {
		this.init()
	},
	methods: {
		keydown(e) {
			if (e.keyCode == 32) {
				e.returnValue = false
			}
		},
		init() {
			this.getDicByCode('PROTYPE')
			this.getDicByCode('YJFX')
			this.getUserInfo()
		},
		getUserInfo() {
			this.$http.get(this.$api.userApi.userinfo, {}).then(({ data }) => {
				let resObj = data.data
				this.avatarImageUrl = this.filePreview + resObj.avatar
				this.signImageUrl = this.filePreview + resObj.electronName
				this.ruleForm = { ...this.ruleForm, ...data.data }
			})
		},
		// 是否可编辑
		editChangeHandle() {
			this.isDisabled = !this.isDisabled
			if (this.isDisabled) {
				this.getUserInfo()
			}
		},
		// 表单提交
		submitForm() {
			this.$refs['ruleForm'].validate(valid => {
				if (valid) {
					let params = {
						...this.ruleForm,
						isAudit: !this.isDisabled,
					}
					this.$http.post(this.$api.userApi.upuserinfo, params).then(({ data }) => {
						if (data.code === 200) {
							this.$cookie.set('X-Web-Token', data.data.token)
							storageUtils.saveUser(data.data.userInfo)
							this.$message({
								message: '操作成功',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.isDisabled = true
									this.getUserInfo()
								},
							})
						}
					})
				}
			})
		},
		// 获取字典
		getDicByCode(code) {
			this.$http.get(this.$api.dicApi.getDicList, { params: { code } }).then(({ data }) => {
				code == 'PROTYPE' && (this.proTypeOptions = data.data)
				code == 'YJFX' && (this.yjfxOptions = data.data)
			})
		},
		// 获取验证码
		getCaptchaHandle() {
			let params = {
				phone: this.ruleForm.phone,
			}
			this.$http.post(this.$api.userApi.getpCaptcha, params).then(({ data }) => {
				console.log(data)
			})
		},
		// 电子签名
		handleSignSuccess(res, file) {
			console.log(res)
			this.signImageUrl = URL.createObjectURL(file.raw)
			this.ruleForm.electronName = res.data.storage.fileUrl
			this.$refs.ruleForm.validateField('electronName')
		},
		// 用户头像
		handleAvatarSuccess(res, file) {
			this.avatarImageUrl = URL.createObjectURL(file.raw)
			this.ruleForm['avatar'] = res.data.storage.fileUrl
			this.$refs.ruleForm.validateField('avatar')
		},
		userTypeChanege(val) {
			this.$refs['ruleForm'].resetFields()
			this.ruleForm.userType = val
		},
	},
}
</script>

<style lang="scss">
.euploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
}
.euploader .el-upload:hover {
	border-color: #409eff;
}
.euploader .desc {
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 22px;
	color: #2962b0;
	font-weight: bold;
	p {
		padding: 0;
		margin: 0;
	}
}
.signimg {
	width: 112px;
	height: 112px;
	display: block;
}
.euploader-icon {
	font-size: 28px;
	text-align: center;
}
.avatar-uploader .el-upload {
	background: #e6e6e6;
	.desc {
		border-radius: 50%;
		background: #fff;
	}
	.avatar {
		width: 112px;
		height: 112px;
		display: block;
		border-radius: 50%;
	}
}
</style>

<style lang="scss" scoped>
.basicinfo {
	display: flex;
	flex-direction: column;
	min-width: max-content;
	padding-bottom: 20px;
	.site_top {
		text-align: center;
		margin-bottom: 30px;
		h3 {
			font-size: 20px;
			line-height: 20px;
			margin: 0;
			padding: 0;
		}
		.line {
			display: inline-block;
			width: 24px;
			border: 1px solid #b7b7b7;
			margin-top: 10px;
		}
	}
	.form_panel {
		.title {
			padding: 6px 10px;
			margin-bottom: 25px;
			background: #f2f3f5;
			display: flex;
			justify-content: space-between;
			.isEdit {
				color: #1670cc;
				background: rgba(22, 112, 204, 0.12);
				padding: 0px 10px;
				border-radius: 12px;
				line-height: 20px;
				height: 18px;
				font-size: 12px;
				cursor: pointer;
			}
		}
		.divtips {
			font-size: 12px;
			margin-bottom: 20px;
			text-align: center;
			color: #66b1ff;
		}
		.tips {
			h3 {
				line-height: 20px;
				margin: 0;
			}
		}
		.btn-control {
			text-align: center;
			margin-top: 60px;
			.elbtnColor {
				width: 160px;
			}
		}
	}
}
</style>
